// extracted by mini-css-extract-plugin
export default {"clinicalVideo":"ClinicalGeneticTesting_clinicalVideo__hV7R8"};